var map = {
	"./bg.jpg": 9093,
	"./bg@2x.jpg": 1179,
	"./body-back.svg": 6454,
	"./body-front.svg": 9154,
	"./body-left.svg": 6597,
	"./body-right.svg": 3817,
	"./brajan.jpg": 3270,
	"./brajan@2x.jpg": 3395,
	"./image1.jpg": 6642,
	"./image2.jpg": 6595,
	"./image3.jpg": 4278,
	"./image4.jpg": 2586,
	"./image5.jpg": 7281,
	"./image6.jpg": 6611,
	"./logo.svg": 1813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5079;